import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Flex from "@/components/Flex";
import CustomTitle from "@/components/app/CustomTitle";

interface TemplateTitleProps {
  handleNavigateBack: () => void;
}

const TemplateTitle = ({ handleNavigateBack }: TemplateTitleProps) => (
  <Flex gap={0.5} alignItems={"center"} mb={1.2}>
    <ArrowBackIcon
      sx={{ cursor: "pointer" }}
      onClick={handleNavigateBack}
      fontSize="medium"
    />
    <CustomTitle
      sx={{ cursor: "pointer" }}
      onClick={handleNavigateBack}
      color={"black"}
    >
      Template
    </CustomTitle>
  </Flex>
);

export default TemplateTitle;
